import React from 'react';
import GoogleLogin from 'react-google-login';
import './GoogleLoginButton.css';

export default class Login extends React.Component {

	constructor(props) {
		super(props);

		this.responseGoogle = this.responseGoogle.bind(this);
	}

	responseGoogle(response) {
		if (!response.error) {
			this.props.onSuccess(response);
		} else if (response.error !== 'popup_closed_by_user') {
			this.props.onError(response.error);
		}
	}

	render() {

		return (
			<GoogleLogin
				tag="div"
				className="login-button"
				clientId={process.env.GOOGLE_APP_ID}
				buttonText=""
				scope="profile"
				fetchBasicProfile="false"
				onSuccess={this.responseGoogle}
				onFailure={this.responseGoogle}
			/>
		);
	}
}



// WEBPACK FOOTER //
// ./src/components/GoogleLoginButton.js